import React, { Component } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { withTranslation } from "react-i18next";
import { FiGrid, FiSearch, FiRefreshCcw, FiList } from "react-icons/fi";
import { FormGroup, FormControl, Button, ButtonGroup } from "react-bootstrap";
import Loading from "components/Loading";
import Layout from "components/Layout";
import moment from "moment";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import PreferenceEdit from "components/Preferences/PreferenceEditModal";
import { showModal, hideModal } from "actions/modalActions";
import * as shiftsActions from "actions/shiftsActions";
import * as employeesActions from "actions/employeesActions";
import Modal from "components/Modal";
import ManagedPreferencesList from "../components/Preferences/ManagedPreferencesList";
import InfiniteScroll from "react-infinite-scroll-component";
import PlanNavigationTabs from "../components/Plans/PlanNavigationTabs";
import { workflowsService } from "services";
import { wfStatus } from "services/workflowsService";

class ManagedPreferences extends Component {
	constructor(props) {
		super(props);

		this.state = {
			focusedInput: null,
			employee_id: -1,
			isSubmit: false,
			isLoading: false,
			is_list_view: true,
			page: 0,
			page_size: 20,
			managed_preferences: [],
			hasMore: true,
		};

		// console.log(props);

		this.closeModal = this.closeModal.bind(this);
		this.openNewPreferenceModal = this.openNewPreferenceModal.bind(this);
		this.openEditPreferenceModal = this.openEditPreferenceModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.handleCancelRequest = this.handleCancelRequest.bind(this);
		this.handleReopenRequest = this.handleReopenRequest.bind(this);
		this.getManagedPreferences = this.getManagedPreferences.bind(this);
	}

	componentDidMount() {
		this.getManagedPreferences();
		this.props.getSelectableEmployees();
		this.props.getAttendanceShifts();
	}

	handleChangeView = (is_list_view) => {
		this.setState({
			is_list_view,
		});
	};

	handleChangeSearch = (event) => {
		const target_id = event.target.id;

		this.setState(
			{
				[target_id]: event.target.value,
				page: 0,
				managed_preferences: [],
				hasMore: true,
			},
			async () => {
				await this.getManagedPreferences();
			}
		);
	};

	onDatesChange = (dates) => {
		var { startDate, endDate } = dates;

		if (startDate) startDate = startDate.format("YYYY-MM-DD");

		if (endDate) {
			endDate = endDate.format("YYYY-MM-DD");
		}

		this.setState(
			{
				page: 0, // reset pagination
				start_from: startDate,
				start_to: endDate,
				managed_preferences: [],
				hasMore: true,
			},
			async () => {
				await this.getManagedPreferences();
			}
		);
	};

	async getManagedPreferences() {
		console.log("entrando a getManagedPreferences");
		this.setState({
			isLoading: this.state.page === 0,
		});
		const {
			start_from,
			start_to,
			employee_id,
			page,
			page_size,
			managed_preferences,
		} = this.state;

		try {
			const response = await workflowsService.getManagedPreferences({
				start_from,
				start_to,
				employee_id,
				page,
				page_size,
			});

			let new_preferences = [];
			let total_items = 0;

			if (response.data) {
				new_preferences = response.data;
				if (response.pagination && response.pagination.total_items) {
					total_items = response.pagination.total_items;
				} else if (response.total) {
					total_items = response.total;
				}
			} else if (Array.isArray(response)) {
				new_preferences = response;
			}

			let all_preferences = managed_preferences;
			if (page === 0) {
				all_preferences = new_preferences;
			} else {
				all_preferences = managed_preferences.concat(new_preferences);
			}

			let hasMore = false;
			if (new_preferences.length > 0) {
				if (total_items > 0) {
					hasMore = all_preferences.length < total_items;
				} else {
					hasMore = new_preferences.length === page_size;
				}
			}

			this.setState({
				managed_preferences: all_preferences,
				isLoading: false,
				hasMore: hasMore,
			});
		} catch (error) {
			console.error("Error fetching managed preferences:", error);
			this.setState({
				isLoading: false,
				hasMore: false,
			});
		}
	}

	fetchMoreData = () => {
		const { page } = this.state;
		this.setState(
			{
				page: page + 1,
			},
			() => {
				this.getManagedPreferences();
			}
		);
	};

	handlePageChange = (page) => {
		this.setState({ page }, () => {
			this.getManagedPreferences();
		});
	};

	closeModal() {
		this.props.hideModal();
	}

	openNewPreferenceModal() {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("preferences.newPreference"),
				style: { width: "500px" },
				content: <PreferenceEdit handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditPreferenceModal(preference, disabled) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: disabled
					? t("preferences.viewPreferenceShift")
					: t("preferences.editPreferenceShift"),
				style: { width: "500px" },
				content: (
					<PreferenceEdit
						preference={preference}
						disabled={disabled}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openAlertModal(message, title) {
		this.props.showModal(
			{
				open: true,
				title: title || "Error",
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	handleCancelRequest(preference) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("preferences.cancelShift"),
				style: { width: "350px" },
				message: t("preferences.cancelShiftConfirm"),
				deleteAction: () => this.confirmCancelRequest(preference),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	confirmCancelRequest = async (preference) => {
		preference.status = wfStatus.canceled;
		preference.shift_id = preference.shift.id;

		if (!this.state.isSubmit) {
			this.setState({ isSubmit: true });
			const response = await workflowsService.update(preference);
			this.setState({ isSubmit: false });

			// console.log(response);
			if (response.ok) {
				toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));

				this.setState(
					{ page: 0, managed_preferences: [], hasMore: true },
					() => {
						this.getManagedPreferences();
					}
				);
				this.closeModal();
			} else {
				if (
					response.errors !== undefined &&
					Object.keys(response.errors).length > 0
				) {
					let textError = response.errors[0].description;
					this.openAlertModal(textError, this.props.t("preferences.errorCancel"));
				} else {
					this.openAlertModal(this.props.t("common.errorGeneric"), this.props.t("preferences.errorCancel"));
				}
			}
		}
	};

	// reabrir solicitud de preferencia
	handleReopenRequest(preference) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("preferences.reopenShift"),
				style: { width: "350px" },
				message: t("preferences.reopenShiftConfirm"),
				deleteAction: () => this.confirmReopenRequest(preference),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	confirmReopenRequest = async (preference) => {
		preference.status = wfStatus.pending;
		preference.shift_id = preference.shift.id;
		this.openEditPreferenceModal(preference, false);

		if (!this.state.isSubmit) {
			this.setState({ isSubmit: true });
			const response = await workflowsService.update(preference);
			this.setState({ isSubmit: false });

			// console.log(response);
			if (response.ok) {
				toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));

				this.props.getEmployeePreferences(this.state.search_employee);
				this.openEditPreferenceModal(preference, false);
				// this.closeModal();
			} else {
				if (
					response.errors !== undefined &&
					Object.keys(response.errors).length > 0
				) {
					let textError = response.errors[0].description;
					console.log(textError);
					toastr.warning(this.props.t("preferences.reopenedWithErrors"), textError);
				}
			}
		}
	};

	getContent = () => {
		if (this.state.isLoading && this.state.page === 0) {
			return <Loading />;
		}

		const { is_list_view, managed_preferences, hasMore } = this.state;

		return (
			<>
				<InfiniteScroll
					dataLength={managed_preferences.length}
					next={this.fetchMoreData}
					hasMore={hasMore}
					loader={
						<div style={{ textAlign: "center", padding: "10px" }}>
							Loading...
						</div>
					}
					endMessage={
						managed_preferences.length > 0 && (
							<p
								className="no-more-results"
								style={{ textAlign: "center", padding: "10px" }}
							>
								{this.props.t("preferences.noMoreRequests")}
							</p>
						)
					}
				>
					<ManagedPreferencesList
						{...this.props}
						managed_preferences={managed_preferences}
						is_list_view={is_list_view}
						openEditPreferenceModal={this.openEditPreferenceModal}
						handleCancelRequest={this.handleCancelRequest}
						handleReopenRequest={this.handleReopenRequest}
					/>
				</InfiniteScroll>
			</>
		);
	};

	render() {
		const { select_employees = [] } = this.props;
		const { is_list_view } = this.state;

		const employee_in_list = select_employees.some(
			(e) => e.id === this.props.user.id
		);
		if (!employee_in_list) select_employees.push(this.props.user);

		let employeeList =
			select_employees.length > 0 &&
			select_employees.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name} {item.surname}
					</option>
				);
			}, this);

		return (
			<>
				<Layout
					configSidebar={false}
					className="page-absences page-preferences"
					context="plan"
				>
					<div className="heading">
						<h1 className="title">{this.props.t("preferences.managedTitle")}</h1>

						<div className="heading-filters">
							<FormGroup
								className="form-group form-select-user mr10"
								controlId="employee_id"
							>
								<FormControl
									type="text"
									placeholder={this.props.t("common.search")}
									value={this.state.employee_id}
									onChange={this.handleChangeSearch}
									as="select"
								>
									<option value="-1">{this.props.t("common.searchEmployee")}</option>
									{employeeList}
								</FormControl>
							</FormGroup>

							<DateRangePicker
								startDateId="startDateId"
								endDateId="endDateId"
								startDate={
									this.state.start_from ? moment(this.state.start_from) : null
								}
								endDate={
									this.state.start_to ? moment(this.state.start_to) : null
								}
								startDatePlaceholderText={this.props.t("common.periodStart")}
								endDatePlaceholderText={this.props.t("common.periodEnd")}
								onDatesChange={this.onDatesChange}
								focusedInput={this.state.focusedInput}
								hideKeyboardShortcutsPanel={true}
								isOutsideRange={() => false}
								minimumNights={0}
								onFocusChange={(focusedInput) =>
									this.setState({ focusedInput })
								}
							/>

							<ButtonGroup aria-label="Preferences view">
								<Button
									variant={`${is_list_view ? "primary" : "default"}`}
									onClick={() => this.handleChangeView(true)}
								>
									<FiList className="icon" />
								</Button>
								<Button
									variant={`${!is_list_view ? "primary" : "default"}`}
									onClick={() => this.handleChangeView(false)}
								>
									<FiGrid className="icon" />
								</Button>
							</ButtonGroup>
						</div>

						<div className="heading-actions">
							<button
								type="button"
								className="btn btn-primary mr10"
								onClick={this.openNewPreferenceModal}
							>
								<FiRefreshCcw className="mr5" />
								{this.props.t("preferences.requestShift")}
							</button>
						</div>
					</div>

					<PlanNavigationTabs />

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.shiftsReducer,
		...reducers.workflowsReducer,
		...reducers.employeesReducer,
		...reducers.plansReducer,
		user: reducers.authReducer.user,
		loading: reducers.workflowsReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllShifts: (options) => dispatch(shiftsActions.getAllShifts(options)),
	getSelectableEmployees: (options) =>
		dispatch(employeesActions.getSelectableEmployees(options)),
	getAttendanceShifts: () => dispatch(shiftsActions.getAttendanceShifts()),
	getEmployeePreferences: (employee_id) =>
		dispatch(employeesActions.getEmployeePreferences(employee_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ManagedPreferences));
